import Content from '../components/content';
import Form from '../components/form';

const contactPageObject = {};

export default {
  init() {},

  finalize() {
    contactPageObject.content = new Content(this);
    contactPageObject.form = new Form();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-contact.js